// React context and toolbar logic extracted from main demo
import React, { createContext, useContext, useState, ReactNode, useEffect } from "react";
import { DatePreset } from "../utils/reportHelpers";
import { DateRange } from "@mui/x-date-pickers-pro";

export type SortField = {
    field: string;
    direction: "Ascending" | "Descending";
};

interface ToolbarContextType {
    datePreset: DatePreset;
    setDatePreset: React.Dispatch<React.SetStateAction<DatePreset>>;
    dateRange: DateRange<Date>;
    setDateRange: React.Dispatch<
        React.SetStateAction<DateRange<Date>>
    >;
    seriesVisibility: { [key: string]: boolean };
    setSeriesVisibility: React.Dispatch<
        React.SetStateAction<{ [key: string]: boolean }>
    >;
    filterExpr: string;
    setFilterExpr: React.Dispatch<React.SetStateAction<string>>;
    sortFields: SortField[];
    setSortFields: React.Dispatch<React.SetStateAction<SortField[]>>;
    exprField: string;
    setExprField: React.Dispatch<React.SetStateAction<string>>;
    exprOp: string;
    setExprOp: React.Dispatch<React.SetStateAction<string>>;
    exprValue: string;
    setExprValue: React.Dispatch<React.SetStateAction<string>>;
    gridFilterChanged: boolean;
    setGridFilterChanged: React.Dispatch<React.SetStateAction<boolean>>;
    chartFilterChanged: boolean;
    setChartFilterChanged: React.Dispatch<React.SetStateAction<boolean>>;
}

const ToolbarContext = createContext<ToolbarContextType | undefined>(undefined);

export const ToolbarProvider = ({ children }: { children: ReactNode }) => {
    const [datePreset, setDatePreset] = useState<DatePreset>("all");
    const [dateRange, setDateRange] = useState<DateRange<Date>>([null, null]);
    const [seriesVisibility, setSeriesVisibility] = useState<{ [key: string]: boolean }>({});
    const [filterExpr, setFilterExpr] = useState("");
    const [sortFields, setSortFields] = useState<SortField[]>([]);
    const [exprField, setExprField] = useState("");
    const [exprOp, setExprOp] = useState("");
    const [exprValue, setExprValue] = useState("");
    const [gridFilterChanged, setGridFilterChanged] = useState<boolean>(false);
    const [chartFilterChanged, setChartFilterChanged] = useState<boolean>(false);

    useEffect(() => {

    }, []);


    return (
        <ToolbarContext.Provider
            value={{
                datePreset,
                setDatePreset,
                dateRange,
                setDateRange,
                seriesVisibility,
                setSeriesVisibility,
                filterExpr,
                setFilterExpr,
                sortFields,
                setSortFields,
                exprField,
                setExprField,
                exprOp,
                setExprOp,
                exprValue,
                setExprValue,
                gridFilterChanged,
                setGridFilterChanged,
                chartFilterChanged,
                setChartFilterChanged,
            }}
        >
            {children}
        </ToolbarContext.Provider>
    );
};

export const useToolbarContext = () => {
    const context = useContext(ToolbarContext);
    if (!context)
        throw new Error("useToolbarContext must be used within a ToolbarProvider");
    return context;
};
